import { render } from "./MyPaddlesView.vue?vue&type=template&id=a7e4e440&scoped=true"
import script from "./MyPaddlesView.vue?vue&type=script&lang=js"
export * from "./MyPaddlesView.vue?vue&type=script&lang=js"

import "./MyPaddlesView.vue?vue&type=style&index=0&id=a7e4e440&lang=scss&scoped=true"

import exportComponent from "/Users/emiliedannenberg/Documents/GitHub/nola-paddle-routes/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a7e4e440"]])

export default __exports__